import { Tooltip } from 'react-tooltip';
import { ICON_BUTTON_ICONS } from '../../../../../components/buttons/IconButton';

/**
 * ContextMenuTooltip - Shared context menu for search result items
 *
 * Displays "Open in new tab" context menu tooltip for both company
 * and individual search results. Reduces duplication between
 * CompanyNameResultItem and IndividualsNameResultItem.
 *
 * @param {string} anchorId - DOM ID of the element to anchor the tooltip to
 * @param {function} onOpenInNewTab - Callback when "Open in new tab" is clicked
 */
const ContextMenuTooltip = ({ anchorId, onOpenInNewTab }) => (
  <Tooltip
    anchorSelect={`#${anchorId}`}
    multiline={true}
    variant="dark"
    opacity={1}
    place="bottom-end"
    clickable={true}
    isOpen={true}
    className="icon-button-tooltip-context-link-menu"
  >
    <button className="context-link-menu-item" onClick={onOpenInNewTab}>
      <span className="left-side">
        <span className="context-link-icon-wrap">
          <img src={ICON_BUTTON_ICONS.BOX_ARROW_UP_RIGHT} alt="" />
        </span>
        <span className="context-link-text">Open in new tab</span>
      </span>
      <span className="right-side"></span>
    </button>
  </Tooltip>
);

export default ContextMenuTooltip;
